import { Injectable } from '@angular/core';

// config
import { appConfig } from '../../../../config/app-config';

// Redux
import { NgRedux, select } from '@angular-redux/store';
import { IAppState } from '../../../../core/store/store';

// store
import {
    uiMessageSnack,
    uiMessageSnackReset
} from '../store/actions';

export type LogType = 'INFO' | 'SUCCESS' | 'WARNING' | 'ERROR';

export interface ILoggable {
    consoleMessage?: string;
    duration?: number;
    uiMessage?: string;
    module?: string;
}

@Injectable()
export class UiMessageSnackService {

    private readonly consoleMethod: { [key: string]: 'log' | 'warn' | 'info' | 'error' } = {
        'SUCCESS': 'log',
        'INFO': 'info',
        'WARNING': 'warn',
        'ERROR': 'error',
    };

    constructor(
        private _store: NgRedux<IAppState>,
    ) { }

    public logMessage(type: LogType, log: ILoggable, ...additional: any[]): void {
        if (log.uiMessage) {
            if (log.duration === undefined) {
                log.duration = appConfig.app.errMsgDurationToShow;
            }
            this._store.dispatch(uiMessageSnack(log.uiMessage, log.module || 'Unknown', type, log.duration));
        }
        if (log.consoleMessage || (additional && additional.length)) {
            console[type](`${Date.now}: ${log.consoleMessage || ''}`, ...additional);
        }
    }

    /**
     * @deprecated Methode ist obsolet, bitte verwende: logMessage
     * @param message 
     * @param module 
     * @param duration 
     */
    public showSnack(
        message: string,
        module: string = 'Unknown',
        duration: number = appConfig.app.errMsgDurationToShow
    ): void {
        this.logMessage('INFO', { uiMessage: message, module, duration });
    }

    /**
     * @deprecated Methode ist obsolet, bitte verwende: logMessage
     * @param message 
     * @param module 
     * @param duration 
     */
    public showSnackInfo(      // same as showSnack
        message: string,
        module: string = 'Unknown',
        duration: number = appConfig.app.errMsgDurationToShow
    ): void {
        this.showSnack(message, module, duration);
    }

    /**
     * @deprecated Methode ist obsolet, bitte verwende: logMessage
     * @param message 
     * @param module 
     * @param duration 
     */
    public showSnackSuccess(
        message: string,
        module: string = 'Unknown',
        duration: number = appConfig.app.errMsgDurationToShow
    ): void {
        this.logMessage('SUCCESS', { uiMessage: message, module, duration });
    }

    /**
     * @deprecated Methode ist obsolet, bitte verwende: logMessage
     * @param message 
     * @param module 
     * @param duration
     */
    public showSnackWarning(
        message: string,
        module: string = 'Unknown',
        duration: number = appConfig.app.errMsgDurationToShow
    ): void {
        this.logMessage('WARNING', { uiMessage: message, module, duration });
    }

    /**
     * @deprecated Methode ist obsolet, bitte verwende: logMessage
     * @param message 
     * @param module 
     * @param duration 
     */
    public showSnackError(
        message: string,
        module: string = 'Unknown',
        duration: number = appConfig.app.errMsgDurationToShow
    ): void {
        this.logMessage('ERROR', { uiMessage: message, module, duration });
    }

    public resetSnack(): void {
        this._store.dispatch(uiMessageSnackReset());
    }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/components/message-snack/service/message-snack.service.ts